export const MESSAGES_STATS_SYNC_INTERVAL = 45000; // slightly offset from 60s so as not to collide with notifications polling
